module.exports = __webpack_public_path__ + "img/logo-jira.09288465.svg";